import React from 'react';
import { useDispatch, useSelector }                 from 'react-redux';

import ActionsList                                  from './treatment/ActionsList';
import AudienceAccuseds                             from './info/AudienceAccuseds';
import AudienceInfo                                 from './info/AudienceInfo';
import AudienceIntervenings                         from './info/AudienceIntervenings';
import AudienceMotives                              from './info/AudienceMotives';
import AudienceProceeding                           from './info/AudienceProceeding';
import AudienceVictims                              from './info/AudienceVictims';

import { AGENDADA, APROBADA, CANCELADA, RECHAZADA } from '../../../data/audienceStates';



const AudienceWorkInfo = () => {

    // Accedo al store
    const audience = useSelector(state => state.audiences.audienceWork);

    // Renderizo
    return (        
        <div className="row">
            <React.Fragment>
                
                <AudienceInfo />

                {   audience && (audience.estado.id === RECHAZADA || audience.estado.id === CANCELADA) 
                        ?
                            <AudienceMotives audience={audience} />
                    
                        : 
                            null
                }

                <AudienceProceeding audience={audience} />

                <AudienceAccuseds audience={audience} />

                {   audience && audience.victimaList && audience.victimaList.length > 0 
                        ?
                            <AudienceVictims audience={audience} />
                        : 
                            null
                }

                {   audience && audience.intervinientesList && audience.intervinientesList.length > 0 
                        ?
                            <AudienceIntervenings audience={audience} />
                        : 
                            null
                }
                
                {   audience && audience.estado && audience.estado.id < APROBADA 
                        ?
                            <ActionsList audience={audience} />
                        : 
                            null
                }
            </React.Fragment>
        </div>
    );
};

export default AudienceWorkInfo;
